const CompleteProfile = () => {
  return <div>Please complete your profile</div>;
};

export default CompleteProfile;